var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2899",
    "data-name": "Grupo 2899",
    transform: "translate(243 1441) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(233 1431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_446",
    "data-name": "Caminho 446",
    d: "M9.877.122a.417.417,0,0,1,0,.59L.711,9.877a.417.417,0,0,1-.59-.59L9.287.122a.417.417,0,0,1,.59,0Z",
    transform: "translate(0.001 0.001)",
    fill: "#d3ff9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_447",
    "data-name": "Caminho 447",
    d: "M.121.122a.417.417,0,0,0,0,.59L9.287,9.877a.417.417,0,0,0,.59-.59L.711.122a.417.417,0,0,0-.59,0Z",
    transform: "translate(0.001 0.001)",
    fill: "#d3ff9a",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonClose);
export default __webpack_public_path__ + "static/media/buttonClose.a75277c83c03cb009399e951102010da.svg";
export { ForwardRef as ReactComponent };